<template>
  <v-container fluid class="dashboard-enlace">
    <v-row>
      <v-col cols="12">
        <div class="glass-card">
          <v-card class="transparent" height="100%" elevation="0">
            <v-card-title class="font-weight-bold justify-center">
              <v-icon left color="secondary" size="28">mdi-chart-bar</v-icon>
              <span class="text-h6">Gráfica de vigencias de elementos activos</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <apexchart ref="apex" height="350" type="bar" :options="options2" :series="series2"></apexchart>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <div class="glass-card card-full-height">
          <v-card class="transparent" height="100%" elevation="0">
            <v-card-title class="subtitle-1 font-weight-bold">
              <v-icon left color="secondary" size="20">mdi-account-clock</v-icon>
              Aspirantes listos para turnar a C3
            </v-card-title>
            <v-card-text>
              <div v-if="aspirantesNoTurnados.length == 0" class="text-body-2 text-center py-8 text--secondary">
                <v-icon size="48" color="secondary" class="mb-2">mdi-information-outline</v-icon>
                <div>No hay información para mostrar.</div>
              </div>
              <template v-else>
                <v-list class="transparent py-0">
                  <v-virtual-scroll height="480" item-height="90" :items="aspirantesNoTurnados">
                    <template v-slot:default="{ item }">
                      <v-hover v-slot="{ hover }">
                        <v-list-item
                          :key="item.idPersonal"
                          two-line
                          class="list-item-modern"
                          :class="{ 'list-item-hover': hover }"
                        >
                          <v-list-item-avatar size="56">
                            <v-avatar color="secondary" size="56" class="avatar-modern">
                              <v-icon color="primary" size="28">mdi-account</v-icon>
                            </v-avatar>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="text-body-1 font-weight-bold mb-1">
                              {{ getFullName(item) }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-body-2">{{
                              getAge(item.fechaNacimiento)
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn
                              icon
                              small
                              @click="openTurnaAspiranteDialog(item)"
                              class="btn-action-modern"
                              :class="{ 'btn-action-hover': hover }"
                            >
                              <v-icon color="secondary">mdi-update</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-hover>
                    </template>
                  </v-virtual-scroll>
                </v-list>
              </template>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
      <v-col cols="3">
        <div class="glass-card card-full-height">
          <v-card class="transparent" height="100%" elevation="0">
            <v-card-title class="subtitle-1 font-weight-bold">
              <v-icon left color="secondary" size="20">mdi-clock-alert</v-icon>
              Aspirantes en espera de resultados
            </v-card-title>
            <v-card-text>
              <div v-if="aspirantesTurnados.length == 0" class="text-body-2 text-center py-8 text--secondary">
                <v-icon size="48" color="secondary" class="mb-2">mdi-information-outline</v-icon>
                <div>No hay información para mostrar.</div>
              </div>
              <template v-else>
                <v-list class="transparent py-0">
                  <v-virtual-scroll height="480" item-height="110" :items="aspirantesTurnados">
                    <template v-slot:default="{ item }">
                      <v-hover v-slot="{ hover }">
                        <v-list-item
                          :key="item.idPersonal"
                          three-line
                          class="list-item-modern"
                          :class="{ 'list-item-hover': hover }"
                        >
                          <v-list-item-avatar size="56">
                            <v-avatar color="secondary" size="56" class="avatar-modern">
                              <v-icon color="primary" size="28">mdi-account</v-icon>
                            </v-avatar>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="text-body-1 font-weight-bold mb-1">
                              {{ getFullName(item) }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-body-2">{{
                              getAge(item.fechaNacimiento)
                            }}</v-list-item-subtitle>
                            <v-list-item-subtitle class="text-body-2">
                              <v-chip x-small color="secondary" class="mt-1"
                                >Resultado C3: {{ item.observacionesC3 }}</v-chip
                              >
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn
                              icon
                              small
                              @click="openResultadoDialog(item)"
                              class="btn-action-modern"
                              :class="{ 'btn-action-hover': hover }"
                            >
                              <v-icon color="secondary">mdi-file-edit</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-hover>
                    </template>
                  </v-virtual-scroll>
                </v-list>
              </template>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
      <v-col cols="3">
        <div class="glass-card card-full-height">
          <v-card class="transparent" height="100%" elevation="0">
            <v-card-title class="subtitle-1 font-weight-bold">
              <v-icon left color="secondary" size="20">mdi-calendar-clock</v-icon>
              Recordatorio mensual de vigencias
            </v-card-title>
            <v-card-text>
              <v-list class="transparent py-0">
                <v-list-item
                  v-for="mes in vigenciaPorMes"
                  :key="mes.nombre"
                  class="list-item-modern px-3"
                  style="cursor: pointer"
                  @click="openVigenciaModal(mes.index, mes.nombre)"
                >
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2 font-weight-medium">{{ mes.nombre }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-chip small :color="mes.cantidad > 0 ? 'secondary' : 'default'" :dark="mes.cantidad > 0">
                      {{ mes.cantidad }}
                    </v-chip>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <turna-aspirante-dialog-component
      :active="turnaAspiranteDialog"
      :aspirante="selectedAspirante"
      @close="turnaAspiranteDialog = false"
    ></turna-aspirante-dialog-component>
    <registro-resultados-aspirante-dialog-component
      :active="resultadosDialog"
      :personal="selectedPersonal"
      @close="resultadosDialog = false"
    ></registro-resultados-aspirante-dialog-component>

    <v-dialog v-model="vigenciaModalOpen" max-width="600">
      <v-card class="glass-card-dialog">
        <v-card-title class="subtitle-1 font-weight-bold">
          <v-icon left color="secondary" size="20">mdi-calendar-clock</v-icon>
          Vigencias {{ vigenciaModalMes ? '— ' + vigenciaModalMes.nombre : '' }}
          <v-spacer />
          <v-btn icon @click="vigenciaModalOpen = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0" style="max-height: 480px; overflow-y: auto">
          <template v-if="vigenciaModalMes">
            <div
              v-if="personalPorMes[vigenciaModalMes.index].length === 0"
              class="text-body-2 text-center py-8 text--secondary"
            >
              <v-icon size="48" color="secondary" class="mb-2">mdi-information-outline</v-icon>
              <div>No hay elementos con vigencia en este mes.</div>
            </div>
            <v-list v-else class="transparent py-0">
              <v-list-item
                v-for="p in personalPorMes[vigenciaModalMes.index]"
                :key="p.idPersonal"
                two-line
                class="list-item-modern"
              >
                <v-list-item-avatar size="44">
                  <v-avatar color="secondary" size="44" class="avatar-modern">
                    <v-icon color="primary" size="24">mdi-account</v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2 font-weight-bold">
                    {{ p.apaterno }} {{ p.amaterno }} {{ p.nombre }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <v-chip small color="secondary" class="mt-1">
                      Vence: {{ formatExpiryDate(p.vigenciaEvaluacionC3) }}
                    </v-chip>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'

const MESES = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
]
import validator from 'validator'
import ActualizaAspiranteDialogComponent from '../../components/profesionalizacion/ActualizaAspiranteDialogComponent.vue'
import TurnaAspiranteDialogComponent from '../../components/enlace/TurnaAspiranteDialogComponent.vue'
import RegistroResultadosAspiranteDialogComponent from '../../components/enlace/RegistroResultadosAspiranteDialogComponent'

export default {
  components: {
    ActualizaAspiranteDialogComponent,
    TurnaAspiranteDialogComponent,
    RegistroResultadosAspiranteDialogComponent,
  },

  async mounted() {
    await this.fetchPersonalByDependencia(1)
    this.setData()
    this.options2 = {
      ...this.options2,
      chart: {
        ...this.options2.chart,
        events: {
          dataPointSelection: (event, chartContext, config) => {
            if (!config.selectedDataPoints[0]?.length) return
            this.openVigenciaModal(config.dataPointIndex, MESES[config.dataPointIndex])
          },
        },
      },
    }
  },

  data() {
    return {
      calendario: '',

      selectedOpen: false,
      selectedEvent: {},
      selectedElement: null,

      selectedAspirante: null,
      selectedPersonal: null,
      turnaAspiranteDialog: false,
      resultadosDialog: false,

      vigenciaModalOpen: false,
      vigenciaModalMes: null,

      options2: {
        chart: {
          type: 'bar',
          background: 'transparent',
          foreColor: '#e0e0e0',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 8,
            distributed: false,
            columnWidth: '60%',
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: MESES,
          labels: {
            style: {
              colors: '#e0e0e0',
              fontSize: '12px',
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: '#e0e0e0',
            },
          },
        },
        grid: {
          borderColor: 'rgba(255, 255, 255, 0.1)',
          strokeDashArray: 4,
        },
        theme: {
          mode: 'dark',
          palette: 'palette1',
        },
        colors: ['#FFA502'],
        tooltip: {
          theme: 'dark',
          style: {
            fontSize: '12px',
          },
        },
      },

      series2: [
        {
          type: 'column',
          data: [],
          name: 'Cantidad de elementos',
        },
      ],
      personalSorteado: [
        { nombre: 'Ernesto Martinez Calderon', cuip: 'MACE891030HMSRLR0912' },
        { nombre: 'Ana López Pérez', cuip: 'LOPA900101MDFRZN01' },
        { nombre: 'Carlos Ruiz Gómez', cuip: 'RUIG850505HDFRRL02' },
        { nombre: 'María Fernanda Torres', cuip: 'TORF920202MDFRRL03' },
        { nombre: 'Luis Alberto Sánchez', cuip: 'SALA880808HDFRRL04' },
      ],
    }
  },

  computed: {
    ...mapGetters('preaspirante', {
      preaspirantes: 'getPreaspirantes',
      aspirantes: 'getAspirantes',
    }),

    ...mapGetters('personal', {
      personal: 'getPersonal',
      personalVigenciaC3: 'getPersonalProximaVigenciaC3',
    }),

    aspirantesNoTurnados() {
      return this.aspirantes.filter((aspirante) => {
        return aspirante.observacionesC3 === ''
      })
    },

    aspirantesTurnados() {
      return this.aspirantes.filter((aspirante) => {
        return aspirante.observacionesC3 === 'NO REGISTRADO'
      })
    },

    vigenciaPorMes() {
      const counts = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.personalVigenciaC3.forEach((p) => {
        const month = moment(p.vigenciaEvaluacionC3, 'YYYY-MM-DD').add(3, 'years').month()
        counts[month]++
      })
      return MESES.map((nombre, i) => ({ nombre, cantidad: counts[i], index: i }))
    },

    personalPorMes() {
      const groups = Array.from({ length: 12 }, () => [])
      this.personalVigenciaC3.forEach((p) => {
        const month = moment(p.vigenciaEvaluacionC3, 'YYYY-MM-DD').add(3, 'years').month()
        groups[month].push(p)
      })
      return groups
    },
  },

  methods: {
    ...mapActions('personal', ['fetchPersonalByDependencia']),

    mostrarEvento(event) {
      this.selectedEvent = event.event
      this.selectedOpen = true
    },

    closeMenu() {
      this.selectedOpen = false
    },

    openTurnaAspiranteDialog(aspirante) {
      this.selectedAspirante = aspirante
      this.turnaAspiranteDialog = true
    },

    openResultadoDialog(personal) {
      this.selectedPersonal = personal
      this.resultadosDialog = true
    },

    getVigenciaProgramada(mes, anio) {
      var mesC3 = moment().month(mes).locale('es').format('M')

      var fecha = anio.toString() + '-' + mesC3.toString()

      return moment(fecha).subtract(7, 'months').format('YYYY-MM')
    },

    setData() {
      this.$refs.apex.updateSeries([
        { type: 'column', data: this.vigenciaPorMes.map((m) => m.cantidad), name: 'Cantidad de elementos' },
      ])
    },

    openVigenciaModal(monthIndex, monthName) {
      this.vigenciaModalMes = { index: monthIndex, nombre: monthName }
      this.vigenciaModalOpen = true
    },

    formatExpiryDate(date) {
      return moment(date, 'YYYY-MM-DD').add(3, 'years').format('DD/MM/YYYY')
    },
  },
}
</script>
<style scoped>
/* ===========================
   DASHBOARD ENLACE C3 - ESTILOS MODERNOS
   =========================== */
.dashboard-enlace {
  background: transparent;
}

/* Glass-morphism dialog card */
.glass-card-dialog {
  background: rgba(30, 30, 30, 0.95) !important;
  border: 1px solid rgba(255, 165, 2, 0.2);
  border-radius: 16px !important;
}

/* Glass-morphism card effect */
.glass-card {
  background: rgba(30, 30, 30, 0.6) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 165, 2, 0.1);
  border-radius: 16px;
  padding: 4px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.glass-card:hover {
  border-color: rgba(255, 165, 2, 0.3);
  box-shadow: 0 8px 32px rgba(255, 165, 2, 0.15);
  transform: translateY(-2px);
}

.card-full-height {
  height: 100%;
}

/* ===========================
   LIST ITEMS MODERNOS
   =========================== */
.list-item-modern {
  border-radius: 12px;
  margin: 8px 0;
  padding: 12px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.03);
}

.list-item-hover {
  background: rgba(255, 165, 2, 0.1) !important;
  transform: translateX(4px);
}

/* Avatar moderno con efecto glass */
.avatar-modern {
  background: rgba(255, 165, 2, 0.15) !important;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 165, 2, 0.3);
  transition: all 0.3s ease;
}

.list-item-hover .avatar-modern {
  border-color: #ffa502;
  box-shadow: 0 0 20px rgba(255, 165, 2, 0.4);
}

/* ===========================
   BOTONES DE ACCIÓN
   =========================== */
.btn-action-modern {
  background: rgba(255, 165, 2, 0.1) !important;
  transition: all 0.3s ease;
}

.btn-action-hover {
  background: rgba(255, 165, 2, 0.2) !important;
  transform: scale(1.1);
}

/* ===========================
   DIVIDERS
   =========================== */
.divider-modern {
  border-color: rgba(255, 255, 255, 0.05) !important;
  margin: 0 16px;
}

/* ===========================
   CARD TITLES CON ICONOS
   =========================== */
::v-deep .v-card__title {
  color: #e0e0e0 !important;
  padding: 20px !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

::v-deep .v-card__title .v-icon {
  margin-right: 8px;
}

/* ===========================
   VIRTUAL SCROLL STYLING
   =========================== */
::v-deep .v-virtual-scroll {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 165, 2, 0.3) rgba(255, 255, 255, 0.05);
}

::v-deep .v-virtual-scroll::-webkit-scrollbar {
  width: 6px;
}

::v-deep .v-virtual-scroll::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
}

::v-deep .v-virtual-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 165, 2, 0.3);
  border-radius: 10px;
}

::v-deep .v-virtual-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 165, 2, 0.5);
}

/* ===========================
   CHIPS MODERNOS
   =========================== */
::v-deep .v-chip.secondary {
  background: rgba(255, 165, 2, 0.15) !important;
  color: #ffa502 !important;
  font-weight: 600;
  border: 1px solid rgba(255, 165, 2, 0.3);
}

::v-deep .v-chip.warning {
  background: rgba(255, 159, 67, 0.15) !important;
  border: 1px solid rgba(255, 159, 67, 0.3);
}

/* ===========================
   LIST STYLING
   =========================== */
::v-deep .v-list-item__title {
  color: #e0e0e0 !important;
  line-height: 1.4;
}

::v-deep .v-list-item__subtitle {
  color: rgba(255, 255, 255, 0.6) !important;
  line-height: 1.3;
}

/* ===========================
   APEXCHARTS DARK THEME OVERRIDE
   =========================== */
::v-deep .apexcharts-canvas {
  background: transparent !important;
}

::v-deep .apexcharts-tooltip {
  background: rgba(30, 30, 30, 0.95) !important;
  border: 1px solid rgba(255, 165, 2, 0.3) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5) !important;
}

::v-deep .apexcharts-tooltip-title {
  background: rgba(255, 165, 2, 0.15) !important;
  border-bottom: 1px solid rgba(255, 165, 2, 0.3) !important;
  color: #ffa502 !important;
}

/* ===========================
   RESPONSIVE ADJUSTMENTS
   =========================== */
@media (max-width: 1264px) {
  .glass-card {
    margin-bottom: 16px;
  }
}

@media (max-width: 960px) {
  ::v-deep .v-virtual-scroll {
    height: 300px !important;
  }
}
</style>
